"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const string_1 = require("../../helpers/string/string");
const Paragraph_styled_1 = require("./Paragraph.styled");
const Paragraph = ({ children, className }) => ((0, jsx_runtime_1.jsx)(Paragraph_styled_1.ParagraphStyled, { className: (0, string_1.getClassName)(className, 'octo'), components: {
        h1: 'h3',
        h2: 'h4',
        h3: 'h5',
        h4: 'h6',
        h5: 'h6',
        h6: 'h6',
    }, children: children }));
exports.Paragraph = Paragraph;
//# sourceMappingURL=Paragraph.js.map